import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, ArrowRight } from "lucide-react";
import { STEP_LABEL, btnPrimary, btnGhost } from "./onboardShared";
import { StepBadge } from "./OnboardBits";

function JobRow({ r, pipeline, gridCols }) {
  return (
    <div data-testid={`domains-job-row-${r.domain}`} className={`grid ${gridCols} items-center px-4 py-2.5 text-sm`}>
      <div className="min-w-0">
        <div className="mono text-zinc-100 truncate flex items-center gap-2">
          {r.ok ? <CheckCircle2 size={13} className="text-emerald-400 shrink-0" /> : <XCircle size={13} className="text-rose-400 shrink-0" />}
          {r.domain}
        </div>
        {r.error && <div className="text-[10px] text-rose-400 truncate">{r.error}</div>}
        {r.site_id && <Link to={`/admin/sites/${r.site_id}`} className="text-[10px] text-amber-400 hover:underline">open site →</Link>}
      </div>
      {pipeline.map((s) => <div key={s} data-testid={`domains-step-${r.domain}-${s}`} className="flex justify-center"><StepBadge state={r.steps?.[s]} /></div>)}
    </div>
  );
}

/** Progress phase: live per-domain × per-step grid polled from the onboarding job. */
export function ProgressPhase({ w }) {
  const { job, pipeline, buyMode, selectedList, lane, switchLane } = w;
  const gridCols = buyMode ? "grid-cols-[1fr_repeat(5,64px)]" : "grid-cols-[1fr_repeat(4,64px)]";
  const done = job?.status === "done";
  const results = job?.results || [];
  return (
    <div className="mt-5 space-y-4">
      <div className="flex items-center gap-2 text-sm">
        {done ? <CheckCircle2 size={16} className="text-emerald-400" /> : <Loader2 size={16} className="animate-spin text-amber-400" />}
        <span className="text-zinc-200">{done ? "Onboarding complete" : "Onboarding in progress"} — {job?.done || 0}/{job?.total || selectedList.length}</span>
      </div>
      <div data-testid="domains-job-grid" className="border border-zinc-800 rounded-sm overflow-hidden">
        <div className={`grid ${gridCols} bg-zinc-900/70 border-b border-zinc-800 label-tiny px-4 py-2`}>
          <div>Domain</div>
          {pipeline.map((s) => <div key={s} className="text-center">{STEP_LABEL[s]}</div>)}
        </div>
        <div className="divide-y divide-zinc-800">
          {results.map((r) => <JobRow key={r.domain} r={r} pipeline={pipeline} gridCols={gridCols} />)}
          {results.length === 0 && <div className="px-4 py-8 text-center text-zinc-500 text-sm">Working… the first domain will appear shortly.</div>}
        </div>
      </div>
      {done && (
        <div className="flex items-center gap-2">
          <Link to="/admin/sites" className={btnPrimary}>View sites <ArrowRight size={15} /></Link>
          <button onClick={() => switchLane(lane)} className={btnGhost}>Onboard more</button>
          <span className="text-xs text-zinc-500 ml-2">Next: select this folder on the Sites page → “Set SparkPost key” to finish email sending setup.</span>
        </div>
      )}
    </div>
  );
}
